// extracted by css-extract-rspack-plugin
export default {"emptyStateContainer":"emptyStateContainer-NBldAo"};